 
import React, { useEffect, useState, forwardRef } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import Spinner from "react-bootstrap/Spinner";
import axios from "axios";
import dayjs from "dayjs";
import { CiUser } from "react-icons/ci";
import { AiOutlineMail } from "react-icons/ai";
import HTMLReactParser from "html-react-parser";
import { BsTelephone } from "react-icons/bs";
import InputGroup from "react-bootstrap/InputGroup";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Select from 'react-select';
import { useGoogleTranslate } from "../GoogleTranslate";
import { BsCalendar } from "react-icons/bs"; // Import the calendar icon
import "./index.css";

function trim(theStr) {
  return theStr.replace(/^\s\s*/, "").replace(/\s\s*$/, "");
}

function getNumbers(inVal, isDouble, removeCharsFromPrefix) {
  var retVal = "";
  var okChars = "0123456789";
  var tmpVal = trim(inVal);
  var curChar = "";
  var isDotFound = false;

  if (tmpVal !== "") {
    for (var i = 0; i < tmpVal.length; i++) {
      curChar = tmpVal.charAt(i);

      if (okChars.indexOf(curChar) !== -1) {
        if (!isDotFound && curChar === "." && isDouble) {
          isDotFound = true;
          retVal = retVal + ".";
        }

        if (retVal === "" && removeCharsFromPrefix.indexOf(curChar) !== -1) {
          //Do nothing
        } else {
          retVal += curChar;
        }
      }
    }
  }

  return retVal;
}

function serialize(form) {
  let inputs = form.elements;
  let testArray = {};
  for (let i = 0; i < inputs.length - 1; i++) {
    testArray[inputs[i].id] = inputs[i].value;
  }
  return testArray;
}

function getParameterByName(name, url = window.location.href) {
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
    results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}

function getFormURL() {
  if (
    window.location.href.split("/")[3] &&
    window.location.href.split("/")[4]
  ) {
    const temp = window.location.href.split("/")[4].replace("#", "");
    return "/" + window.location.href.split("/")[3] + "/" + temp;
  } else {
    return "/";
  }
}

export default function SignUpForm({ Lodata , defaultLanguage}) {
  const Loanofficer = Lodata.Loanofficer;
  const [validated, setValidated] = useState(false);
  const [formLoading, setFormLoading] = useState(false);
  const [leadNo, setLeadNo] = useState("");
  const [email, setEmail] = useState("");
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [phone, setPhone] = useState("");
  const [consentValueSlot, setConsentValueSlot] = useState(true);
  const [showContactForm, setShowContactForm] = useState(true);
  const [showConsenSection, setShowConsenSection] = useState(false);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showFailModal, setShowFailModal] = useState(false);
  const [showClickToMoreOpt, setShowClickToMoreOpt] = useState(true);
  const [referrerName, setReferrerName] = useState("");
  const [comment, setComment] = useState("");
  const [message, setMessage] = useState("");
  const [validationNote, setValidationNote] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [placeholderVisible, setPlaceholderVisible] = useState(true);
  const [selectedTime, setSelectedTime] = useState("");
  const [activeDates, setActiveDates] = useState([]);
  const [activeTimeSlots, setActiveTimeSlots] = useState([]);
  const [activeDays, setActiveDays] = useState([]);
  const [selectedDay, setSelectedDay] = useState(null);
  const [dateInvalid, setDateInvalid] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [showPhotoConsentMoreOpt, setShowPhotoConsentMoreOpt] = useState(true);
  const { getCurrentLanguage } = useGoogleTranslate();
  const [currentLanguage, setCurrentLanguage] = useState(defaultLanguage || 'en');

  const queryParams = new URLSearchParams(window.location.search);
  const key = queryParams.get("key");
  const utmSource = queryParams.get("utm_source") || undefined;
  const utmMedium = queryParams.get("utm_medium") || undefined;
  const utmCampaign = queryParams.get("utm_campaign") || undefined;
  const utmContent = queryParams.get("utm_content") || undefined;

  // Language-specific content
  const content = {
    en: {
      formHeader: "Register for the Free Class",
      formSubheader: "Fill out the form below to reserve your spot.",
      firstNamePlaceholder: "First Name",
      lastNamePlaceholder: "Last Name",
      emailPlaceholder: "Email ID",
      phonePlaceholder: "Phone Number",
      messagePlaceholder: "Message",
      preferredDatePlaceholder: "Preferred Class Date",
      submitButton: "Submit",
      backButton: "Back",
      continueButton: "Continue",
      consentText: "Do you consent to Automated Phone Solicitation?",
      showMore: "(click to show more)",
      showLess: "(click to show less)",
      iConsent: "I Consent",
      iDoNotConsent: "I DO NOT Consent",
      termsText: {
        part1: "By clicking on \"Submit\" below you agree to Sun West Mortgage Company, Inc.'s NMLS 3277",
        part2: "and",
        part3: "; and you agree to Celligence International, LLC.'s (\"Celligence\")",
        part4: "and",
        part5: ", all of which you may access by clicking on the \"Terms and Conditions\" or \"Security Policy\" web links contained herein."
      },
      links: {
        termsConditions: "Terms and Conditions",
        securityPrivacy: "Security and Privacy Policy"
      },
      photoConsentText: "I hereby give comprehensive, royalty free, and blanket permission to be recorded at the event",
      readTerms: "(click to read recording terms & conditions).",
      showLess: "(click to show less)",
      photoConsentDetails: "By clicking \"I Consent\" below, you expressly consent to Sun West Mortgage Company, Inc. making (or allowing Sun West Mortgage Company, Inc. employees and agents making, solely on Sun West Mortgage Company, Inc.'s behalf) a phone call, text message or voicemail transmission to the phone number you entered above, for the purpose of soliciting your purchase of consumer services, including mortgage services (including using our automated system for the selection or dialing of phone numbers, the playing of a recorded message when a connection is made, or the transmission of a pre-recorded voicemail), even if the phone number you entered above is on a national, state, or internal Do Not Call Registry. You are not required to click on \"I Consent\" below (directly or indirectly) or agree to receive such phone calls, text messages, or voicemail transmissions as a condition of receiving any consumer services, including mortgage services from Sun West Mortgage Company, Inc. or its affiliates.",
      successTitle: "Thank You for Registering!",
      failMessage: "Due to technical difficulties your request could not be processed. Please contact us at inquiry@swmc.com.",
      invalidFirstName: "Please enter a valid First Name.",
      invalidLastName: "Please enter a valid Last Name.",
      invalidEmail: "Please enter a valid Email Address.",
      invalidPhone: "Please enter a valid Telephone Number.",
      invalidDate: "Please select a date.",
      pleaseWait: "Please wait..."
    },
    es: {
      formHeader: "Regístrate para la Clase Gratuita",
      formSubheader: "Completa el formulario a continuación para reservar tu lugar.",
      firstNamePlaceholder: "Nombre",
      lastNamePlaceholder: "Apellido",
      emailPlaceholder: "Correo Electrónico",
      phonePlaceholder: "Número de Teléfono",
      messagePlaceholder: "Mensaje",
      preferredDatePlaceholder: "Fecha de clase preferida",
      submitButton: "Enviar",
      backButton: "Volver",
      continueButton: "Continuar",
      consentText: "¿Consiente la Solicitud Telefónica Automatizada?",
      showMore: "(haga clic para mostrar más)",
      showLess: "(haga clic para mostrar menos)",
      iConsent: "Doy mi Consentimiento",
      iDoNotConsent: "NO Doy mi Consentimiento",
      termsText: {
        part1: "Al hacer clic en \"Enviar\" a continuación, acepta los términos de Sun West Mortgage Company, Inc. NMLS 3277",
        part2: "y",
        part3: "; y acepta los términos de Celligence International, LLC. (\"Celligence\")",
        part4: "y",
        part5: ", a los que puede acceder haciendo clic en los enlaces web \"Términos y Condiciones\" o \"Política de Seguridad\" contenidos en este documento."
      },
      links: {
        termsConditions: "Términos y Condiciones",
        securityPrivacy: "Política de Seguridad y Privacidad"
      },
      photoConsentText: "Por la presente doy permiso integral, libre de regalías y general para ser grabado en el evento",
      readTerms: "(haga clic para leer los términos y condiciones de grabación).",
      showLess: "(haga clic para mostrar menos)",
    photoConsentDetails: "Al hacer clic en \"Doy mi Consentimiento\" a continuación, usted expresamente consiente que Sun West Mortgage Company, Inc. realice (o permita que los empleados y agentes de Sun West Mortgage Company, Inc. realicen, únicamente en nombre de Sun West Mortgage Company, Inc.) una llamada telefónica, mensaje de texto o transmisión de correo de voz al número de teléfono que ingresó anteriormente, con el propósito de solicitar su compra de servicios al consumidor, incluidos servicios hipotecarios (incluido el uso de nuestro sistema automatizado para la selección o marcación de números de teléfono, la reproducción de un mensaje grabado cuando se establece una conexión o la transmisión de un correo de voz pregrabado), incluso si el número de teléfono que ingresó anteriormente está en un registro nacional, estatal o interno de No Llamar. No está obligado a hacer clic en \"Doy mi Consentimiento\" a continuación (directa o indirectamente) o aceptar recibir dichas llamadas telefónicas, mensajes de texto o transmisiones de correo de voz como condición para recibir cualquier servicio al consumidor, incluidos servicios hipotecarios de Sun West Mortgage Company, Inc. o sus afiliados.",
      successTitle: "¡Gracias por Registrarse!",
      failMessage: "Debido a dificultades técnicas, su solicitud no pudo ser procesada. Por favor contáctenos en inquiry@swmc.com.",
      invalidFirstName: "Por favor, ingrese un nombre válido.",
      invalidLastName: "Por favor, ingrese un apellido válido.",
      invalidEmail: "Por favor, ingrese una dirección de correo electrónico válida.",
      invalidPhone: "Por favor, ingrese un número de teléfono válido.",
      invalidDate: "Por favor, seleccione una fecha.",
      pleaseWait: "Por favor espere..."
    }
  };
  
  const formText = content[currentLanguage] || content.en;
  
  const options = [
    { value: 'May 17, 2025', label: 'May 17, 2025' },
    { value: 'May 24, 2025', label: 'May 24, 2025' },
    { value: 'May 31, 2025', label: 'May 31, 2025' }
  ];

  // Listen for language changes
  useEffect(() => {
    const checkLanguage = () => {
      const lang = getCurrentLanguage();
      setCurrentLanguage(lang);
    };
    
    // Initial check
    checkLanguage();
    
    // Set up an interval to check for language changes
    const intervalId = setInterval(checkLanguage, 1000);
    
    return () => clearInterval(intervalId);
  }, [getCurrentLanguage, defaultLanguage]);
  
  
  useEffect(() => {
    const fetchData = () => {
      if (
        Loanofficer &&
        Loanofficer.slots &&
        Loanofficer.slots.hosts.length > 0
      ) {
        const hosts = Loanofficer.slots.hosts;
        const activeDates = [];
        const activeDays = [];
        const activeTimeSlots = [];

        hosts.forEach((host) => {
          host.availability.forEach((availability) => {
            if (
              availability.activeDates &&
              availability.activeDates.length > 0
            ) {
              activeDates.push(...availability.activeDates);
            }

            if (availability.activeDays && availability.activeDays.length > 0) {
              activeDays.push(...availability.activeDays);
            }

            if (
              availability.activeTimeSlots &&
              availability.activeTimeSlots.length > 0
            ) {
              activeTimeSlots.push(...availability.activeTimeSlots);
            }
          });
        });

        setActiveDates(activeDates);
        setActiveDays(activeDays);
        setActiveTimeSlots(activeTimeSlots);
      }
    };

    fetchData();
  }, [Loanofficer]);

  const formatDateString = (date) => {
    return dayjs(date).format("YYYY-MM-DD");
  };

  const handleDateChange = (date) => {
    if (!date) {
      setDateInvalid(true);
      setSelectedDate(null);
      setSelectedTime("");
      return;
    }

    // Convert string to Date if necessary
    const dateObject = typeof date === "string" ? new Date(date) : date;
    setSelectedDate(dateObject);

    // Only proceed with availability checks if Loanofficer and its properties exist
    if (!Loanofficer?.slots?.hosts?.[0]?.availability) {
      console.warn("Availability data is not properly structured");
      setActiveTimeSlots([]);
      setDateInvalid(false);
      return;
    }

    const formattedDate = dayjs(dateObject).format("YYYY-MM-DD");
    const dayOfWeek = dayjs(dateObject).format("dddd").toLowerCase();

    // Find the availability for the selected day
    const availability = Loanofficer.slots.hosts[0].availability.find(
      (entry) => {
        if (!entry?.activeDates || !entry?.activeDays) return false;

        const isDateAvailable = entry.activeDates.includes(formattedDate);
        const isDayAvailable = entry.activeDays.some(
          (day) => day.toLowerCase() === dayOfWeek
        );
        return isDateAvailable || isDayAvailable;
      }
    );

    // Set active time slots for the selected date
    if (availability?.activeTimeSlots) {
      setActiveTimeSlots(availability.activeTimeSlots);
    } else {
      setActiveTimeSlots([]);
    }

    setDateInvalid(false);
  };

  const handleTimeChange = (e) => {
    const time = e.target.value;
    setSelectedTime(time);
  };

  const generateDatesFromDays = () => {
    const currentDate = dayjs();
    const days = activeDays.map((day) => day.toLowerCase());

    const generatedDates = [];
    for (let i = 0; i < 365; i++) {
      const date = currentDate.add(i, "day");
      const dayOfWeek = dayjs(date).format("dddd").toLowerCase();
      if (
        days.includes(dayOfWeek) ||
        activeDates.includes(date.format("YYYY-MM-DD"))
      ) {
        generatedDates.push(date.toDate());
      }
    }
    return generatedDates;
  };

  // const handleTimeChange = (e) => {
  //   const time = e.target.value;
  //   setSelectedTime(time);
  // };

  const handleFailClose = () => {
    setShowFailModal(false);
    setValidated(false);
  };
  const handleSuccessClose = () => {
    setShowSuccessModal(false);
    setValidated(false);
  };

  const clearForm = () => {
    setLeadNo("");
    setFirstName("");
    setLastName("");
    setEmail("");
    setPhone("");
    setComment("");
    setMessage("");
    setReferrerName("");
    setConsentValueSlot(true);
    setValidationNote("");
    setSelectedDate("");
    setSelectedTime("");
  };

  const goBackToFirstPage = () => setShowConsenSection(false);

  //Below is the function to remove non-printable ASCII chars
  //and special chars from the pass string
  function removeNonAsciiSpecialCharacters(str) {
    //check if pass value is null or blank.
    //return empty string if pass value is null or blank
    if (str === null || str === "") {
      return "";
    } else {
      //convert the pass value to string
      str = str.toString();
      //remove non-printable ASCII chars and replace it with empty string
      str = str.replace(/[^\x20-\x7E]/g, "");
      //replace all special characters with empty string
      str = str.replace(/[`~!@#$%^&*()_|+\-=?;:'",.<>{}0-9\[\]\\\/]/g, "");
      //return updated string to calling function
      return str;
    }
  }

  //first name validation
  const handleFirstName = (evt) => {
    let tempFirstName = evt.currentTarget.value;
    tempFirstName = removeNonAsciiSpecialCharacters(tempFirstName);
    if (tempFirstName) {
      if (tempFirstName.includes(" ") && lastName === "") {
        const name = tempFirstName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setFirstName(tempFirstName.trim());
      }
    } else {
      setFirstName("");
    }
  };

  //last name validation
  const handleLastName = (evt) => {
    let tempLastName = evt.currentTarget.value;
    tempLastName = removeNonAsciiSpecialCharacters(tempLastName);
    if (tempLastName) {
      if (tempLastName.includes(" ") && firstName === "") {
        const name = tempLastName.split(" ");
        let fName = name[0];
        let lName = name.slice(1).join(" ");
        setFirstName(fName.trim());
        setLastName(lName.trim());
      } else {
        setLastName(tempLastName.trim());
      }
    } else {
      setLastName("");
    }
  };

  const handleReferrerName = (e) => {
    setReferrerName(e.target.value);
  };

  const handleEmailAddress = (evt) => {
    let tempEmailAddress = evt.currentTarget.value;
    if (tempEmailAddress) {
      setEmail(tempEmailAddress.trim());
    } else {
      setEmail("");
    }
  };

  // Phone number validation
  const handleTelephoneNumber = (evt) => {
    //Save Phone number in local storage for Apply
    var tmpVal = trim(getNumbers(evt.currentTarget.value, false, "01"));
    var FirstThreeDigit = tmpVal.substring(0, 3);
    var FirstSixDigit = tmpVal.substring(0, 6);

    /* Below Pattern will check numbers between below ranges
                456, 555, 900,
                100, 101, ..., 199
                211, 311, ..., 911  ***811 removed
                370, 371, ..., 379
                960, 961, ..., 969
                800, 801, ..., 855  ***removed
                866, 877, 888, 800855
                */
    var patt =
      /^(1[0-9][0-9])|([2-7]11)|(911)|(37[0-9])|(96[0-9])|(456)|(555)|(866)|(877)|(888)|(900)$/;
    var patt2 = /^800855$/;
    if (patt.test(FirstThreeDigit)) {
      evt.currentTarget.value = "";
      return;
    } else if (patt2.test(FirstSixDigit)) {
      evt.currentTarget.value = "";
      return;
    }

    var curChar = "";
    var areaCode = "";
    var firstThree = "";
    var lastFour = "";
    var extension = "";

    if (tmpVal !== "") {
      for (var i = 0; i < tmpVal.length; i++) {
        curChar = tmpVal.charAt(i);

        if (i < 3) areaCode += curChar;
        if (i < 6 && i > 2) firstThree += curChar;
        if (i < 10 && i > 5) lastFour += curChar;
        if (i > 9) extension += curChar;
      }
    }

    var retVal = "";

    /* Do not put the parentesis if we only have the first three digits of the phone number.
                Once we are past that then start formatting the phone number. This was the main issue
                why the phone number couldn't be blanked out in it's entirety.*/
    if (areaCode !== "" && firstThree === "") retVal += areaCode;
    else if (areaCode !== "" && firstThree !== "")
      retVal += "(" + areaCode + ")";

    if (firstThree !== "") retVal += " " + firstThree;

    if (lastFour !== "") retVal += "-" + lastFour;

    if (extension !== "") retVal += " x" + extension;
    else setPhone(retVal);
  };

  const showPhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(false);
  };

  const hidePhoneSoliticationConsent = () => {
    setShowClickToMoreOpt(true);
  };

  const showPhotoConsent = () => {
    setShowPhotoConsentMoreOpt(false);
  };

  const hidePhotoConsent = () => {
    setShowPhotoConsentMoreOpt(true);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const form = event.currentTarget;

    if (form.checkValidity() === false) {
      event.stopPropagation();
    } else {
      setFormLoading(true);

      const signupFormData = document.querySelector("#signupForm");
      const getData = serialize(signupFormData);
      const signupForm = document.getElementById("signupForm");

      const firstName_ = getData.firstName;
      const lastName_ = getData.lastName;
      const phoneNumber_ = getData.phone;
      const email_ = getData.email;
      const comments_ = getData.comment;
      const referrerName_ = Loanofficer.referrerName;
      const chs_name = getData["chs:name"];
      const selectedDate_ = selectedDate
        ? dayjs(selectedDate).format("MMMM D, YYYY") // Format the selected date
        : ""; // Format the selected date

      let formUrl = getFormURL();

      if (showConsenSection === true && consentValueSlot !== null) {
        const axiosData = {
          firstName: firstName_,
          lastName: lastName_,
          phone: phoneNumber_,
          referrerName: referrerName_,
          email: email_,
          referrerSource: "THEWAYTOYOUROWNHOME",
          "chs:name": chs_name,
          utmSource: utmSource,
          utmMedium: utmMedium,
          utmCampaign: utmCampaign,
          utmContent: utmContent,
          formUrl: formUrl,
          leadSource: "THEWAYTOYOUROWNHOME",
          TCPA_Consent_Given: consentValueSlot,
          comments: selectedDate_ || comments_, // Include selectedDate in comments
          consentVersion: "1.1",
          consentVersionText: "By clicking “I Consent” below, you expressly consent to Sun West Mortgage Company, Inc. making (or allowing Sun West Mortgage Company, Inc. employees and agents making, solely on Sun West Mortgage Company, Inc.’s behalf) a phone call, text message or voicemail transmission to the phone number you entered above, for the purpose of soliciting your purchase of consumer services, including mortgage services (including using our automated system for the selection or dialing of phone numbers, the playing of a recorded message when a connection is made, or the transmission of a pre-recorded voicemail), even if the phone number you entered above is on a national, state, or internal Do Not Call Registry. You are not required to click on “I Consent” below (directly or indirectly) or agree to receive such phone calls, text messages, or voicemail transmissions as a condition of receiving any consumer services, including mortgage services from Sun West Mortgage Company, Inc. or its affiliates."
        };

        axios
          .post(process.env.REACT_APP_API_EMAIL, axiosData)
          .then((res) => {
            setLeadNo(res.data.success.brokerId);
            setShowConsenSection(false);
            setShowSuccessModal(true);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            clearForm();
            setFormLoading(false);
          })
          .catch(function (error) {
            setShowFailModal(false);
            setShowSuccessModal(false);
            signupForm.classList.remove("was-validated");
            signupForm.reset();
            setFormLoading(false);
            if (!showConsenSection) {
              setShowConsenSection(true);
            }
          });

        const axiosConfig = {
          headers: {
            "Content-Type": "application/json",
          },
        };

        try {
          // Acknowledgement email to loan officer
          await axios.post(
            process.env.REACT_APP_SEND_EMAIL,
            {
              fromEmailAddress: "inquiry@swmc.com",
              toEmailAddress: [email],
              emailSubjectLine:
                "You’re Registered! Free Homeownership Class with Joaquin Claudio",
              emailBody: `<div><div><p>Hi ${firstName},</p><p>
              Thank you for registering for the Free Homeownership Class! Looking forward to seeing you and helping you take the next step towards homeownership.
  </p></div>`,
            },
            axiosConfig
          );

          let inquiryEmailRecipients;

          if (Loanofficer.bookslotInquiryEmailRecipient.includes(",")) {
            inquiryEmailRecipients = Loanofficer.bookslotInquiryEmailRecipient
              .split(",")
              .map((email) => email.trim());
          } else {
            inquiryEmailRecipients = [
              Loanofficer.bookslotInquiryEmailRecipient,
            ];
          }

          // Inquiry email to loan officer
          await axios.post(
            process.env.REACT_APP_SEND_EMAIL,
            {
              fromEmailAddress: "inquiry@swmc.com",
              toEmailAddress: inquiryEmailRecipients,
              emailSubjectLine: `Registration received for - The Way to your Own Home! - ${firstName_} ${lastName_}`,
              emailBody: `<div><b>Name:</b> ${firstName_} ${lastName_}</div><div><b>Email:</b> ${email_}</div><div><b>Phone:</b> ${phoneNumber_}</div><div><b>Message:</b> ${comments_}</div>`,
            },
            axiosConfig
          );
        } catch (error) {
          // Handle the error if needed
        }
      } else {
        setShowFailModal(false);
        setShowSuccessModal(false);
        signupForm.classList.remove("was-validated");
        signupForm.reset();
        setFormLoading(false);
        if (!showConsenSection) {
          setShowConsenSection(true);
        }
      }
    }

    setValidated(true);
  };


  useEffect(() => {
    if (key) {
      axios
        .post(
          process.env.REACT_APP_SUNSOFT_API_GET_SESSION_KEY,
          { key: key },
          {
            headers: { "Content-Type": "application/json" },
          }
        )
        .then((response) => {
          let userData = response.data.parameters;
          if (userData.borrowerName) {
            // If the borrower name contains a space, split the first and last name.
            let name = userData.borrowerName.split(" ");
            setFirstName(name[0]);
            setLastName(name.slice(1).join(" "));
          } else {
            // If there is no borrower name, set the first and last name accordingly.
            if (userData.borrowerFirstName) {
              setFirstName(userData.borrowerFirstName);
            }
            if (userData.borrowerLastName) {
              setLastName(userData.borrowerLastName);
            }
          }
          setPhone(userData.borrowerPhone);
          setEmail(userData.emailAddress);

          return response;
        })
        .catch((error) => {
          // console.error("Get GET_SESSION_KEY Error: ", error);
        });
    }
  }, []);

  const CustomDatePickerInput = forwardRef(({ value, onClick }, ref) => (
    <input
      type="text"
      className="form-control"
      value={value}
      onClick={onClick}
      readOnly // Make the input field read-only
      placeholder="Select Date"
      required
      ref={ref} // Forward the ref to the input element
    />
  ));

  return (
    <div className="formWrapper pad-form" id="ContactForm">
      <Container>
        <div className="formBody">
          <Container className="form-container">
            <Row>
              <Col sm={12} className="ContactUsFormBox">
                {!showConsenSection && (
                  <div className="formHeader notranslate">
                    <h3>{formText.formHeader}</h3>
                    <p>{formText.formSubheader}</p>
                  </div>
                )}
                {showContactForm && (
                  <Form
                    id="signupForm"
                    autoComplete="off"
                    method="POST"
                    noValidate
                    onSubmit={handleSubmit}
                    validated={validated}
                  >
                    <Row>
                      <Col sm={12} className="d-none">
                        <Form.Group controlId="leadNo" className="form-group">
                          <Form.Control
                            aria-label="Lead Number"
                            placeholder="Lead Number"
                            type="text"
                            value={leadNo}
                            disabled
                          />
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group
                          controlId="firstName"
                          className="form-group"
                        >
                          <InputGroup className="mb-3">
                            <InputGroup.Text
                              id="user-icon"
                              styles={{ background: "#ffff" }}
                            >
                              <CiUser className="user" />
                            </InputGroup.Text>
                            <Form.Control
                              aria-label="First Name"
                              onChange={(e) => setFirstName(e.target.value)}
                              onBlur={handleFirstName}
                              placeholder={formText.firstNamePlaceholder}
                              required={lastName === ""}
                              type="text"
                              value={firstName}
                              className={firstName ? "active notranslate" : "notranslate"}
                            />
                            <Form.Control.Feedback type="invalid">
                             {formText.invalidFirstName}
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="lastName" className="form-group">
                          <InputGroup className="mb-3">
                            <InputGroup.Text
                              id="user-icon"
                              styles={{ background: "#ffff" }}
                            >
                              <CiUser className="user" />
                            </InputGroup.Text>
                            <Form.Control
                              aria-label="Last Name"
                              onChange={(e) => setLastName(e.target.value)}
                              placeholder={formText.lastNamePlaceholder}
                              onBlur={handleLastName}
                              required={firstName === ""}
                              type="text"
                              value={lastName}
                              className={lastName ? "active notranslate" : "notranslate"}
                            />
                            <Form.Control.Feedback type="invalid">
                            {formText.invalidLastName}
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="email" className="form-group">
                          <InputGroup className="mb-3">
                            <InputGroup.Text
                              id="user-icon"
                              styles={{ background: "#ffff" }}
                            >
                              <AiOutlineMail className="user" />
                            </InputGroup.Text>
                            <Form.Control
                              aria-label="Email Address"
                              onChange={handleEmailAddress}
                              pattern="^[a-zA-Z0-9_\-\.]+@[a-zA-Z0-9\-]+(?:\.[a-zA-Z0-9\-]{2,64})$"
                              placeholder={formText.emailPlaceholder}
                              required
                              type="text"
                              value={email}
                              className={email ? "active notranslate" : "notranslate"}
                            />
                            <Form.Control.Feedback type="invalid">
                            {formText.invalidEmail}
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="phone" className="form-group">
                          <InputGroup className="mb-2">
                            <InputGroup.Text
                              id="user-icon"
                              styles={{ background: "#ffff" }}
                            >
                              <BsTelephone className="user" />
                            </InputGroup.Text>
                            <Form.Control
                              aria-label="Telephone Number"
                              maxLength={21}
                              minLength={14}
                              onChange={handleTelephoneNumber}
                              pattern="^(\(\d{3}\)|\d{3})-?\s?\d{3}-?\s?\d{4}( ?x\d{1,7})?$"
                              placeholder={formText.phonePlaceholder}
                              required
                              // required={email === ""}
                              type="text"
                              value={phone}
                              className={phone ? "active notranslate" : "notranslate"}
                            />
                            <Form.Control.Feedback type="invalid">
                            {formText.invalidPhone}
                            </Form.Control.Feedback>
                          </InputGroup>
                        </Form.Group>
                      </Col>
{/* 
                      <Col sm={12} className={showConsenSection ? "d-none" : "d-block"}>
  <div className="schedule">
    <div className="date-time-zone">
      <Form.Group controlId="dateSelection" className="form-group">
        <InputGroup className="mb-2 flex-nowrap">
          <InputGroup.Text id="user-icon" style={{ background: "#ffff" }}>
            <BsCalendar className="calendar" />
          </InputGroup.Text>
          <Form.Label className="visually-hidden">Select a date:</Form.Label> */}
          
          {/* React-Select Component */}
          {/* <div className="w-100">
            <Select
              options={[
                { value: '', label: formText.preferredDatePlaceholder },
                { value: 'May 06, 2025', label: 'May 06, 2025' },
                { value: 'May 08, 2025', label: 'May 08, 2025' },
                { value: 'May 10, 2025', label: 'May 10, 2025' }
              ]}
              value={selectedDate ? { value: selectedDate, label: selectedDate } : null}
              onChange={(selectedOption) => setSelectedDate(selectedOption ? selectedOption.value : null)}
              placeholder={formText.preferredDatePlaceholder}
              className="react-select-container notranslate"
              classNamePrefix="react-select"
              isSearchable={false}
              styles={{
                control: (base) => ({
                  ...base,
                  background: 'transparent',
                  border: 'none',
                  borderTop: '1px solid white !important',
                  borderBottom: '1px solid white !important',
                  borderRight: '1px solid white !important',
                  borderLeft: 'none !important',
                  boxShadow: 'none',
                  minHeight: '38px',
                  '&:hover': {
                    borderTop: '1px solid white !important',
                    borderBottom: '1px solid white !important',
                    borderRight: '1px solid white !important'
                  }
                }),
                placeholder: (base) => ({
                  ...base,
                  color: 'white !important',
                  fontSize: '11px !important',
                  textAlign: 'left',
                  textAlign: 'left',
                  fontWeight: '400',
                  marginLeft: '4px'
                }),
                menu: (base) => ({
                  ...base,
                  background: 'linear-gradient(180deg, #4A0022 0%, #0A628E 100%)',
                  border: '1px solid white',
                  textAlign: 'left',
                  borderRadius: '4px',
                  overflow: 'hidden'
                }),
                menuList: (base) => ({
                  ...base,
                  padding: 0,
                  textAlign: 'left',
                  background: 'transparent'
                }),
                option: (base, state) => ({
                  ...base,
                  background: state.isSelected 
                    ? 'rgba(255, 255, 255, 0.2)' 
                    : 'transparent',
                  color: 'white !important',
                  textAlign: 'left',
                  fontSize: '12px',
                  '&:hover': {
                    background: 'rgba(255, 255, 255, 0.1) !important'
                  }
                }),
                singleValue: (base) => ({
                  ...base,
                  color: 'white !important',
                  textAlign: 'left',
                  fontSize: '12px'
                }),
                dropdownIndicator: (base) => ({
                  ...base,
                  color: 'white !important',
                  '&:hover': {
                    color: 'white !important'
                  }
                }),
                indicatorSeparator: () => ({ 
                  display: 'none' 
                })
              }}
            />
          </div> */}
          
          {/* <Form.Control.Feedback type="invalid">
            {formText.invalidDate}
          </Form.Control.Feedback>
        </InputGroup>
      </Form.Group>
    </div>
  </div>
</Col> */}

                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <Form.Group controlId="comment" className="form-group">
                          <Form.Control
                            rows="3"
                            aria-label="comment"
                            placeholder={formText.messagePlaceholder}
                            as="textarea"
                            value={comment}
                            onChange={(e) => setComment(e.target.value)}
                            className={comment ? "active notranslate" : "notranslate"}
                          />
                        </Form.Group>
                      </Col>
                      
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <div className="d-flex">
                          {showClickToMoreOpt ? (
                            <h6
                            className="consentSmall notranslate"
                              onClick={showPhoneSoliticationConsent}
                            >
                              {formText.consentText}{" "}
                              <span
                                id="showConsentText"
                                className="consentLink showConsentText notranslate"
                                title="Show Phone Solicitation Consent"
                              >
                                {formText.showMore}
                              </span>
                            </h6>
                          ) : (
                            <h6
                              className="consentSmall notranslate"
                              onClick={hidePhoneSoliticationConsent}
                            >
                              {formText.consentText}{" "}
                              <span
                                id="hideConsentText"
                                className="consentLink hideConsentText notranslate"
                                title="Hide Phone Solicitation Consent"
                              >
                                {formText.showLess}
                              </span>
                            </h6>
                          )}
                        </div>

                        {!showClickToMoreOpt ? (
                          <p
                            id="phoneSolicitationTerms"
                            className="consent-font pb-0 notranslate"
                          >
                             {formText.photoConsentDetails}
                          </p>
                        ) : (
                          ""
                        )}
                      </Col>

                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <Form.Check
  aria-label={formText.iConsent}
  defaultChecked
  className="checkIConsent notranslate"
  translate="no"
  id="iConsentSlot"
  label={formText.iConsent}
  name="checkIConsent"
  onClick={() => setConsentValueSlot(true)}
  type="radio"
/>
<Form.Check
  aria-label={formText.iDoNotConsent}
  className="checkIConsent notranslate"
  translate="no"
  id="iDoNotConsentSlot"
  label={formText.iDoNotConsent}
  name="checkIConsent"
  onClick={() => setConsentValueSlot(false)}
  type="radio"
/>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <p className="consent-font notranslate" translate="no">
    {formText.termsText.part1}{" "}
    <a
      href="https://www.swmc.com/terms-and-conditions"
      target="_blank"
      className="form-link notranslate"
      rel="noopener noreferrer"
      translate="no"
    >
      {formText.links.termsConditions}
    </a>{" "}
    {formText.termsText.part2}{" "}
    <a
      href="https://www.swmc.com/privacy-policy"
      target="_blank"
      className="form-link notranslate"
      rel="noopener noreferrer"
      translate="no"
    >
      {formText.links.securityPrivacy}
    </a>
    {formText.termsText.part3}{" "}
    <a
      href="https://celligence.com/terms"
      target="_blank"
      className="form-link notranslate"
      rel="noopener noreferrer"
      translate="no"
    >
      {formText.links.termsConditions}
    </a>{" "}
    {formText.termsText.part4}{" "}
    <a
      href="https://celligence.com/privacy"
      target="_blank"
      className="form-link notranslate"
      rel="noopener noreferrer"
      translate="no"
    >
      {formText.links.securityPrivacy}
    </a>
    {formText.termsText.part5}
  </p>
                      </Col>
                      <div className={showConsenSection ? "d-none" : "d-block"}>
                        {showPhotoConsentMoreOpt ? (
                          <p
                          className="photoConsent notranslate"
                          translate="no"
                          onClick={showPhotoConsent}
                        >
                          {formText.photoConsentText}{" "}
                          <span
                            id="showPhotoConsentText"
                            className="photoConsentLink showPhotoConsentText notranslate"
                            translate="no"
                            title="Show Photo Recording Terms & Conditions"
                          >
                            {formText.readTerms}
                          </span>
                        </p>
                      ) : (
                        <p
                          className="photoConsent mb-2 notranslate"
                          translate="no"
                          onClick={hidePhotoConsent}
                        >
                          {formText.photoConsentText}{" "}
                          <span
                            id="hidePhotoConsentText"
                            className="photoConsentLink hidePhotoConsentText notranslate"
                            translate="no"
                            title="Hide Photo Recording Terms & Conditions"
                          >
                            {formText.showLess}
                          </span>
                        </p>
                      )}
                    </div>
                    {!showPhotoConsentMoreOpt ? (
                      <p
                        id="photoRecordingTerms"
                        className={showConsenSection ? "d-none" : "consent-font pb-0 notranslate"}
                        translate="no"
                      >
                        {formText.photoConsentDetails}
                      </p>
                    ) : (
                      ""
                    )}
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-none" : "d-block"}
                      >
                        <div className="divflex">
                          <div>
                            <Button className="btn-submit notranslate" type="submit">
                              {formLoading ? (
                                <>
                                  <Spinner
                                    animation="border"
                                    aria-hidden="true"
                                    as="span"
                                    role="status"
                                    size="md"
                                  />{" "}
                                  {formText.pleaseWait}
                                </>
                              ) : (
                                <>{formText.submitButton}</>
                              )}
                            </Button>
                          </div>
                        </div>
                      </Col>
                      <Col
                        sm={12}
                        className={showConsenSection ? "d-block" : "d-none"}
                      >
                        <div className="divflex">
  <div className="backBtnDiv">
    <Button
      className="btn-submit notranslate"
      translate="no"
      type="button"
      onClick={goBackToFirstPage}
    >
      {formText.backButton}
    </Button>
  </div>
  <div className="continueBtnDiv btnAdjustDiv">
    <Button
      className="btn-submit notranslate"
      translate="no"
      type="submit"
      variant="success"
    >
      {formLoading ? (
        <>
          <Spinner
            animation="border"
            aria-hidden="true"
            as="span"
            role="status"
            size="sm"
          />{" "}
          {formText.pleaseWait}
        </>
      ) : (
        formText.continueButton
      )}
    </Button>
  </div>
</div>
                      </Col>
                    </Row>
                  </Form>
                )}
              </Col>
            </Row>
          </Container>
          <Modal
            size="md"
            centered
            show={showSuccessModal}
            onHide={() => {
              handleSuccessClose();
            }}
            backdrop="static"
          >
            <Modal.Header closeButton />
            <Modal.Body className="text-center">
              <h6>Thank You for Registering!</h6>
              {/* <h6>We're excited to have you join us for the Sweet Heart of an Event with Tenuta Torciano Winery.</h6>
              <h6>You'll receive a confirmation email shortly.</h6> */}
              
            </Modal.Body>
          </Modal>
          <Modal
            size="md"
            centered
            show={showFailModal}
            onHide={handleFailClose}
            backdrop="static"
          >
            <Modal.Header closeButton />
            <Modal.Body>
              <h4>
                Due to technical difficulties your request could not be
                processed. Please contact us at&nbsp;
                <a href={"mailto:inquiry@swmc.com"} className="form-link">
                  inquiry@swmc.com
                </a>
                .
              </h4>
            </Modal.Body>
          </Modal>
        </div>
      </Container>
    </div>
  );
}